<template>
  <div>
    <!-- 产品列表 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>回收站</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <div class="conentTitle">
        <el-input placeholder="产品名称" v-model="data.name" clearable />
        <el-input placeholder="产品ID" v-model="data.ProductID" clearable />
        <el-button type="primary" @click="inquire">查询</el-button>
        <el-button type="primary" @click="btns">恢复产品</el-button>
      </div>
     
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="ProductID" label="ID" ></el-table-column>
        <el-table-column  label="分类">
          <template slot-scope="scope">
            <span>{{ scope.row.ProductType=='1'?'门票':scope.row.ProductType=='2'?'冰雪':scope.row.ProductType=='3'?'场馆':scope.row.ProductType=='4'?'课程':scope.row.ProductType=='5'?'滑冰':scope.row.ProductType=='6'?'户外扩展':scope.row.ProductType=='7'?'水上乐园':
          scope.row.ProductType=='9'?'马术':scope.row.ProductType=='10'?'旱雪':scope.row.ProductType=='11'?'保龄球':scope.row.ProductType=='12'?'冲浪':scope.row.ProductType=='13'?'篮球':scope.row.ProductType=='14'?'洗浴':scope.row.ProductType=='15'?'美食':scope.row.ProductType=='16'?'夏令营':scope.row.ProductType=='17'?'健身':scope.row.ProductType=='18'?'房雪套餐':scope.row.ProductType=='19'?'冬令营':scope.row.ProductType=='20'?'套票':'' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ProductName" label="产品名称" width="200"></el-table-column>
        <el-table-column prop="Price" label="门市价"></el-table-column>
        <el-table-column prop="SellPrice" label="建议价"></el-table-column>
        <el-table-column prop="AgentPrice" label="代理价"></el-table-column>
        <el-table-column prop="NumBerflag" label="每日限制">
          <template  slot-scope="scope">
            <span>{{ scope.row.NumBerflag=='0'?'无限制':scope.row.NumBerflag }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DayNum" label="已售(每日)"></el-table-column>
        <el-table-column prop="Number" label="总限制">
          <template  slot-scope="scope">
            <span>{{ scope.row.Number=='0'?'无限制':scope.row.Number }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="AllNum" label="已售(总)"></el-table-column>
        <el-table-column prop="address" label="状态">
          <template  slot-scope="scope">
            <div class="cursor" v-if="scope.row.UseFlag=='0'" @click="setup(1,scope.row.ProductID)">
              <img src="@/images/scenic/dl.png" alt />
              <span style="margin-left:9px">上线</span>
            </div>
            <div class="cursor"  v-if="scope.row.UseFlag=='1'"  @click="setup(0,scope.row.ProductID)">
              <img src="@/images/scenic/dh.png" alt />
              <span style="margin-left:9px">下线</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="退款">
          <template  slot-scope="scope">
            <div v-if="scope.row.ReturnFlag=='0'">
              <img src="@/images/scenic/dl.png" alt />
              <span style="margin-left:9px">可退</span>
            </div>
            <div  v-if="scope.row.ReturnFlag=='1'">
              <img src="@/images/scenic/dh.png" alt />
              <span style="margin-left:9px">不可退</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data.total" :page-size="data.page_size" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 排序弹框开始 -->
    <!-- <proLiPxdialog v-if="pxvisible" ref="pxDialog" :tableData="tableData" :data="data"></proLiPxdialog> -->
    <!-- 排序弹框结束 -->
 
  </div>
</template>

<script>
import { deleteProductList , recoverAllProduct } from '@/request/scenic.js'
import { MessageBox } from 'element-ui';
export default {
  data() {
    return {
      tableData: [
      ],
      multipleSelection:[],
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8,
        total:0,
        name:'',
        ProductID:''
      }
    };
  },
  created(){
    this.getList()
  },
  methods: {
    inquire(){
      this.data.page = 1
      this.getList()
    },
    btns(){
      if(this.multipleSelection.length==0){
        this.$message.error('请选择产品')
        return false
      }
      MessageBox(`此操作将批量恢复产品, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.multipleSelection.map(item=>{ 
          id += item.ProductID + ','
        })
        id = id.slice(0,-1)
        let data = {
          ProductIds:id,
          token:window.sessionStorage.getItem('Token'),
        }
        recoverAllProduct(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('产品恢复成功')
            this.getList()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
    },
 
    
  
 
   
    // 获取产品列表数据
    getList(){
      deleteProductList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
        }
      })
    },
    // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    },
   // 全选
   handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-card__body {
  padding: 0 20px;
}
.conentBox {
  margin-top: 17px;
  .conentTitle {
    margin: 2rem 0;
    display: flex;
    flex-wrap: wrap;
    .el-input,
    .el-select {
      width: 22rem;
      margin-right: 1rem;
      margin-bottom: 1rem;
    }
    .el-button {
      margin-bottom: 1rem;
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    > div:nth-child(1) {
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      .conentBtn {
        margin-bottom: 10px;
        // width: 120px;
        .el-button {
          width: 100px;
          // width: 84%;
          background: #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    > div:nth-child(2) {
      // width: 50%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-left: auto;
      .scenicBtnDel {
        .el-button {
          width: 92px;
          background: #ffffff;
          border: 1px solid #ff4d4f;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ff4d4f;
          box-sizing: border-box;
        }
      }
      .scenicBtnPx {
        margin: 0 20px;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height */
          box-sizing: border-box;
          color: #246deb;
        }
      }
      .scenicBtn {
        .el-button {
          width: 120px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          box-sizing: border-box;
          color: #246deb;
        }
      }
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
::v-deep .el-popover__reference{
  color: #FF4D4F;
  margin-right: 1.9rem;
  cursor: pointer;
}

.conentRow /deep/ .el-button{
  color: #fff;
  background: #246deb;
}
/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
.totla{
  position: absolute;
  left: 2rem;
  width: 35rem;
  color: red !important;
}
.detele_btns{
  border-radius: 0.4rem;
  margin: 0 2rem;
  width: 9.2rem;
  height: 3.8rem;
  border: 1px solid #FF4D4F;
  color: #FF4D4F;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  cursor: pointer;
}
</style>